import { event } from 'vue-gtag'

import i18n from '@/i18n/i18n'
import { BrandService } from '@/services/retailer/BrandService'

import { build_query, errorMessage } from '@/utilities/helpers'

import { BRAND_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['name', 'id', 'has_retailer_stock_input']

export const allowedSorts = ''
export const allowedIncludes = ''
export const allowedAppends = ''

export const state = {
  brands: [],
  unbrandedBrand: null,
  brandsInStock: null
}

export const mutations = {
  SET_BRANDS(state, brands) {
    state.brands = brands
  },
  SET_UNBRANDED_BRAND(state, brand) {
    state.unbrandedBrand = brand
  },
  SET_BRANDS_IN_STOCK(state, brands) {
    state.brandsInStock = brands
    state.meta = brands.meta
  }
}

export const actions = {
  getBrands({ commit }) {
    return new Promise(resolve => {
      const brandService = new BrandService()
      brandService.getBrands().then(response => {
        commit('SET_BRANDS', response.data)
        resolve(response.data)
      })
    })
  },
  getBrandsInStock({ commit, state }, query) {
    const newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)
    return new Promise(resolve => {
      const brandService = new BrandService()
      brandService.getBrandsInStock(newQuery).then(response => {
        commit('SET_BRANDS_IN_STOCK', response)
        resolve(response)
      })
    })
  },
  getBrandById({}, brandId) {
    return new Promise(resolve => {
      const brandService = new BrandService()
      brandService.getBrandById(brandId).then(response => {
        resolve(response.data)
      })
    })
  },
  getBrandsByCategory({ dispatch }, categoryId) {
    return new Promise((resolve, reject) => {
      const brandService = new BrandService()
      brandService
        .getBrandsByCategory(categoryId)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: BRAND_ERROR_MESSAGES.getBrandsError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getUnbrandedBrand({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      const brandService = new BrandService()
      brandService
        .getUnbrandedBrand()
        .then(response => {
          commit('SET_UNBRANDED_BRAND', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: BRAND_ERROR_MESSAGES.getUnbrandedBrandError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  attachBrand({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      const brandService = new BrandService()
      brandService
        .attachBrand(params)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.added', { element: t('views.retailer.brands.brand') })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          commit('SET_BRANDS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: BRAND_ERROR_MESSAGES.attachBrandError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  removeBrand({ commit, dispatch, state }, params) {
    return new Promise(resolve => {
      const brandService = new BrandService()
      const deletedBrand = state?.brands?.find(brand => brand?.pivot?.brand_id === params?.brandId)
      brandService.removeBrand(params.categoryId, params.brandId).then(response => {
        if (deletedBrand) {
          event('brand_actions', {
            event_action: 'brand_deleted',
            brand: {
              category: deletedBrand?.pivot?.category?.name,
              name: deletedBrand?.name
            }
          })
        }
        commit('SET_BRANDS', response.data)
        const notification = {
          type: 'warning',
          message: t('store.shared.deleted', { element: t('views.retailer.brands.brand') })
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  }
}
